import { render } from "./ChartPanel.vue?vue&type=template&id=348534ef&scoped=true"
import script from "./ChartPanel.vue?vue&type=script&lang=js"
export * from "./ChartPanel.vue?vue&type=script&lang=js"

import "./ChartPanel.vue?vue&type=style&index=0&id=348534ef&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348534ef"]])

export default __exports__